/**
 * ShortLinkRedirect — /s/:slug page. Fetches the target from the backend
 * and window.location.replaces so the browser's back button doesn't get
 * stuck on this transient page.
 */
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function ShortLinkRedirect() {
  const { slug } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/short-links/${encodeURIComponent(slug)}/resolve`);
        const target = r.data?.target_url;
        if (!target) throw new Error("empty target");
        // Use replace so the short URL doesn't pollute browser history.
        window.location.replace(target);
      } catch {
        setError(true);
      }
    })();
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6"
           data-testid="short-link-error">
        <div className="pf-card p-8 max-w-md w-full text-center space-y-3">
          <div className="font-display text-slate-900 text-2xl">Link expired or unknown</div>
          <p className="text-sm text-slate-600">This short link doesn't resolve to a target. It may have been deleted or mistyped.</p>
          <Link to="/" className="pf-btn-primary inline-flex items-center gap-1 px-4 py-2 rounded-full text-xs font-semibold mt-2"
                data-testid="short-link-home">Back to Cyannect</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
         data-testid="short-link-loading">
      <div className="text-sm text-slate-500 font-mono">Redirecting…</div>
    </div>
  );
}
